import React from 'react';
import { Icon } from './Icon.js';
export const IconVolumeFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M11 9.85184C10.9998 11.0278 9.70807 11.7463 8.70898 11.1263L5.28711 9.00028H2.75C1.50744 9.00028 0.500132 7.99281 0.5 6.75028V5.25028C0.5 4.00764 1.50736 3.00028 2.75 3.00028H5.28516L8.70801 0.874302C9.70715 0.25359 10.9998 0.971551 11 2.14774V9.85184Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconVolumeFill12.js.map